import { Book, Image } from '@life/frontend-model'
import { S3Image, StoryImage } from '@life/model'

export function storyImageToImage(book: Book, row: StoryImage): Image {
  const img = book.findImage(row.id)
  return img ?? new Image(book, { original: '', web: '', thumb: '' } as S3Image)
}
